import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

class NavButtons extends Component {
  handleNext = (e) => {
    if (!this.props.disabled) {
      return this.props.next(e);
    }

    return false;
  };

  handleBack = (e) => {
    if (!this.props.disabled) {
      return this.props.prev(e);
    }

    return false;
  };

  render() {
    const { disabled } = this.props;

    if (this.props.direction === 'back') {
      return (
        <div className="nav-button left" onClick={this.handleBack}>
          <FontAwesome name="caret-left" />
          <div>Back</div>
        </div>
      );
    } else if (this.props.direction === 'next') {
      return (
        <div className="nav-button right" onClick={this.handleNext}>
          <div>Next</div>
          <FontAwesome name="caret-right" />
        </div>
      );
    } else {
      return (
        <div
          className="nav-button right"
          onClick={this.handleNext}
          disabled={disabled}
        >
          {disabled && <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>}
          <button>Send</button>
        </div>
      );
    }
  }
}

export default NavButtons;



// WEBPACK FOOTER //
// src/components/NavButtons.jsx